import { parseURL } from 'whatwg-url'

export const isValidUrl = (url: string) => {
  return parseURL(url)
}

export const isAlcoholNull = (value: any) => value == null || value === ''
